export type BaseItem = { id: number }

export function useSelectedItemMixin<T extends BaseItem>(baseStore: any) {
  const toggleSelectedItem = (id: number) => {
    const index = baseStore.selectedItems.value.findIndex(
      (selectedItem: T) => selectedItem.id === id
    )
    if (index !== -1) {
      baseStore.selectedItems.value.splice(index, 1)
    } else {
      const item = baseStore.items.value.find((item: T) => item.id === id)
      if (item) baseStore.selectedItems.value.push(item)
    }
  }

  const addSelectedItem = (id: number) => {
    const item = baseStore.items.value.find((item: T) => item.id === id)
    const index = baseStore.selectedItems.value.findIndex(
      (selectedItem: T) => selectedItem.id === id
    )
    if (item && index === -1) baseStore.selectedItems.value.push(item)
  }
  const removeSelectedItem = (id: number) => {
    const index = baseStore.selectedItems.value.findIndex(
      (selectedItem: T) => selectedItem.id === id
    )
    if (index !== -1) baseStore.selectedItems.value.splice(index, 1)
  }

  return {
    toggleSelectedItem,
    addSelectedItem,
    removeSelectedItem
  }
}
